import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
    <div>
        <h1>404 - Pagina no encontrada!</h1>
        <Link to="/dashboard">
        Regresar
        </Link>
    </div>
);

export default NotFound;